import { render, staticRenderFns } from "./Activity4_2.vue?vue&type=template&id=e6f56bd0&scoped=true&"
import script from "./Activity4_2.vue?vue&type=script&lang=js&"
export * from "./Activity4_2.vue?vue&type=script&lang=js&"
import style0 from "./Activity4_2.vue?vue&type=style&index=0&id=e6f56bd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6f56bd0",
  null
  
)

export default component.exports